// Per-tab keys: "boost" | "shoutout" | "manager"
const perTabInit = { entries: [], hasMore: false, lastDoc: null };

const initState = {
  tabs: {
    boost:    { ...perTabInit },
    shoutout: { ...perTabInit },
    manager:  { ...perTabInit },
  },
  loading:        false, // initial page load spinner
  loadingMore:    false, // load-more button spinner
  profileLoading: false,
  userProfile:    null,
  opinions:       [],
  opinionsLoading: false,
};

const boostReducer = (state = initState, action) => {
  switch (action.type) {

    // ── per-tab pagination ──────────────────────────────────────────────────
    case "SET_TAB_ENTRIES": {
      const { key, entries } = action.payload;
      return {
        ...state,
        tabs: { ...state.tabs, [key]: { ...state.tabs[key], entries } },
      };
    }
    case "APPEND_TAB_ENTRIES": {
      const { key, entries } = action.payload;
      return {
        ...state,
        tabs: {
          ...state.tabs,
          [key]: {
            ...state.tabs[key],
            entries: [...state.tabs[key].entries, ...entries],
          },
        },
      };
    }
    case "SET_TAB_HAS_MORE": {
      const { key, hasMore } = action.payload;
      return {
        ...state,
        tabs: { ...state.tabs, [key]: { ...state.tabs[key], hasMore } },
      };
    }
    case "SET_TAB_LAST_DOC": {
      const { key, lastDoc } = action.payload;
      return {
        ...state,
        tabs: { ...state.tabs, [key]: { ...state.tabs[key], lastDoc } },
      };
    }
    case "RESET_TAB": {
      const { key } = action.payload;
      return {
        ...state,
        tabs: { ...state.tabs, [key]: { ...perTabInit } },
      };
    }

    // ── loaders ─────────────────────────────────────────────────────────────
    case "SET_BOOST_LOADING":
      return { ...state, loading: action.payload };
    case "SET_BOOST_LOADING_MORE":
      return { ...state, loadingMore: action.payload };

    // ── profile ─────────────────────────────────────────────────────────────
    case "SET_PROFILE_LOADING":
      return { ...state, profileLoading: action.payload };
    case "SET_USER_PROFILE":
      return { ...state, userProfile: action.payload };
    case "CLEAR_USER_PROFILE":
      return { ...state, userProfile: null, profileLoading: false };

    // ── opinions ────────────────────────────────────────────────────────────
    case "SET_OPINIONS":
      return { ...state, opinions: action.payload };
    case "SET_OPINIONS_LOADING":
      return { ...state, opinionsLoading: action.payload };
    case "CLEAR_OPINIONS":
      return { ...state, opinions: [], opinionsLoading: false };

    default:
      return { ...state };
  }
};

export default boostReducer;
